/**
 * 全局历史数据 store
 * 客户端可拉取最新数据并更新
 * 集成在线学习:数据更新后自动训练
 */
import { create } from 'zustand';
import { history as baseHistory } from '../data/history.js';
import { maybeTrainOnline } from '../lib/mlOnline.js';

const CACHE_KEY = 'fucai3d_latest_history_v1';
const ONLINE_KEY = 'fucai3d_online_model_v1';

function loadCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && Array.isArray(parsed.data)) return parsed;
  } catch {}
  return null;
}

function saveCache(history) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      data: history,
      updatedAt: Date.now(),
    }));
  } catch {}
}

// 启动时如果有缓存的 online model,加载
async function loadOnlineModel() {
  try {
    const raw = localStorage.getItem(ONLINE_KEY);
    if (!raw) return;
    const { setModel } = await import('../lib/mlPredict.js');
    setModel(JSON.parse(raw));
    console.log('[Store] 已加载缓存的 online model');
  } catch (e) {
    console.error('[Store] 加载 online model 失败:', e);
  }
}
loadOnlineModel();

export const useHistoryStore = create((set, get) => ({
  history: (() => {
    const cached = loadCache();
    if (cached && cached.data && cached.data[0]) {
      const merged = [...cached.data, ...baseHistory].reduce((acc, x) => {
        if (!acc.find(y => y.p === x.p)) acc.push(x);
        return acc;
      }, []).sort((a, b) => parseInt(b.p) - parseInt(a.p));
      return merged;
    }
    return baseHistory;
  })(),
  updatedAt: loadCache()?.updatedAt || null,
  refreshing: false,
  training: false,
  trainingProgress: null,

  refresh: async (fetchFn) => {
    if (get().refreshing) return;
    set({ refreshing: true });
    try {
      const fresh = await fetchFn();
      if (!fresh || fresh.length === 0) throw new Error('未拉到数据');
      const merged = [...fresh, ...get().history].reduce((acc, x) => {
        if (!acc.find(y => y.p === x.p)) acc.push(x);
        return acc;
      }, []).sort((a, b) => parseInt(b.p) - parseInt(a.p));
      set({ history: merged, updatedAt: Date.now() });
      saveCache(merged);

      // 触发在线学习(后台跑)
      set({ training: true, trainingProgress: '准备数据...' });
      const merged_history = merged;
      maybeTrainOnline(merged_history, false).then(async (res) => {
        if (res.ok) {
          // 缓存 online model
          try {
            const { getModel } = await import('../lib/mlPredict.js');
            localStorage.setItem(ONLINE_KEY, JSON.stringify(getModel()));
          } catch (e) {
            console.error('[Store] 缓存 online model 失败:', e);
          }
        }
        set({ training: false, trainingProgress: null });
      });

      return { ok: true, latest: fresh.sort((a, b) => parseInt(b.p) - parseInt(a.p))[0] };
    } finally {
      set({ refreshing: false });
    }
  },
}));
